import { render, staticRenderFns } from "./WishlistDropdown.vue?vue&type=template&id=5b7ddf01&scoped=true&"
import script from "./WishlistDropdown.vue?vue&type=script&lang=js&"
export * from "./WishlistDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WishlistDropdown.vue?vue&type=style&index=0&id=5b7ddf01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7ddf01",
  null
  
)

export default component.exports